import React, { useMemo } from 'react';
import { useGetAssignmentWithVideoIdQuery } from '../../features/assignment/assignmentApi';
import AssignmentTab from './AssignmentTab';
import QuizTab from './QuizTab';

const VideoDetailsAndPlayer = ({ url, title, createdAt, views, description, duration, id }) => {

    const formattedDate = useMemo(() => {
        const date = new Date(createdAt);
        const day = date.getDate();
        const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    }, [createdAt])
    return (
        < >
            <iframe width="100%" className="aspect-video" src={url}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe>

            <div>
                <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                    {title}
                </h1>
                <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
                    Uploaded on {formattedDate}
                </h2>

                <div className="flex gap-4">
                    <AssignmentTab videoId={id}></AssignmentTab>
                    <QuizTab videoId={id}></QuizTab>
                </div>
                <p className="mt-4 text-sm text-slate-400 leading-6">
                    {description}
                </p>


            </div>
        </>
    );
};

export default VideoDetailsAndPlayer;